import {FC} from 'react'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import {
  getInvoiceDateAgeInDays,
  INVOICE_REGISTRATION_DEADLINE_DAYS,
  isInvoiceDatePastRegistrationDeadline,
} from '../core/invoiceDateDeadline'
import './InvoiceDateDeadlineHint.css'

type Props = {
  date?: string | null
}

const InvoiceDateDeadlineHint: FC<Props> = ({date}) => {
  if (!isInvoiceDatePastRegistrationDeadline(date)) return null

  const ageInDays = Math.floor(getInvoiceDateAgeInDays(date) || 0)
  const popover = (
    <Popover
      id='invoice-date-deadline-popover'
      className='mp-invoice-date-deadline-popover'
      dir='rtl'
    >
      <Popover.Header as='h3'>هشدار مهلت ارسال به سامانه مؤدیان</Popover.Header>
      <Popover.Body>
        <p>
          تاریخ انتخاب‌شده حدود <strong>{ageInDays} روز</strong> قبل است؛ بنابراین ارسال این
          صورتحساب ممکن است مشمول قواعد مهلت زمانی باشد. مهلت عملیاتی نهایی در لحظه ارسال و بر
          اساس تنظیم مرکزی سرور بررسی می‌شود.
        </p>
        <p>
          این هشدار مانع ذخیره صورتحساب در برنامه نیست. اگر سازمان امور مالیاتی برای شرایط یا بازه
          زمانی مشخصی تمدید رسمی اعلام کرده باشد، مهلت همان اطلاعیه ملاک است. پیش از ارسال، آخرین
          اطلاعیه رسمی و وضعیت کارپوشه مالیاتی را بررسی کنید.
        </p>
      </Popover.Body>
    </Popover>
  )

  return (
    <OverlayTrigger trigger='click' placement='bottom' rootClose overlay={popover}>
      <button
        type='button'
        className='mp-invoice-date-deadline-hint'
        aria-label='مشاهده هشدار مهلت ارسال صورتحساب'
        title={`هشدار اولیه برای صورتحساب‌های قدیمی‌تر از ${INVOICE_REGISTRATION_DEADLINE_DAYS} روز`}
        onClick={(event) => event.stopPropagation()}
      >
        <i className='las la-exclamation-triangle' aria-hidden='true'></i>
      </button>
    </OverlayTrigger>
  )
}

export {InvoiceDateDeadlineHint}
